import Icon from 'components/icons/Icon';
import { cx } from 'stuff';


interface ExpandIconProps
{
	is_expanded: boolean,
	handleToggle: (c : boolean) => void
}


const ExpandIcon = ({ is_expanded, handleToggle } : ExpandIconProps) =>
{
	return <div 
		className={cx('tree_junction_icon', {is_expanded: is_expanded})}
		onClick={e => handleToggle(!is_expanded)}
	>
		<Icon
			of={is_expanded ? 'triangle_down' : 'triangle_right'}
			size='25px'
		/>
	</div>
}


export default ExpandIcon;